import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { zodDeleteContractImportJobEndpointSchema } from './validations';

/**
 * Soft-deletes a contract import job by its ID. The record is retained in
 * the database; only its status is affected.
 *
 * @param jobId - The ID of the import job to delete.
 * @param options - Optional request options (e.g., abort signal).
 * @returns {Promise<void>} Resolves when the delete succeeds; the API returns no payload.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Contract-Import-Jobs/operation/delete_import_job_contracts_import_jobs__job_id__delete
 */
export const deleteContractImportJob = async (
  jobId: UUID,
  options?: KyRequestOptions,
) => {
  await vestigasApi.delete(ENDPOINT.CONTRACT_IMPORT_JOB.DELETE(jobId), {
    ...options,
    validate: {
      ...options?.validate,
      pathSegments: zodDeleteContractImportJobEndpointSchema,
    },
  });
};
